enum PortalUIMode {
    LightMode = "LIGHT",
    DarkMode = "DARK",
    MatchBrowser = "BROWSER",
}
export default PortalUIMode
